import get from 'lodash/get';
import { createSelector } from 'reselect';
import initialState from './initialState';

const EMPTY_VERSIONS = initialState.versions;

/**
 * Every release returned by the endpoint, rendered as tabs in payload order.
 * @param {Object} state - Redux state.
 * @returns {Object[]} Releases.
 */
export const selectWhatsNewVersions = (state) => get(state, 'whatsNew.versions', EMPTY_VERSIONS);

/**
 * Public changelog URL shown in the modal footer.
 * @param {Object} state - Redux state.
 * @returns {string} Changelog URL.
 */
export const selectWhatsNewChangelogUrl = (state) => get(state, 'whatsNew.changelogUrl', initialState.changelogUrl);

/**
 * Whether the changelog request is in flight.
 * @param {Object} state - Redux state.
 * @returns {boolean} Fetching flag.
 */
export const selectWhatsNewIsFetching = (state) => get(state, 'whatsNew.isFetching', initialState.isFetching);

/**
 * Whether the changelog was already fetched in this page load.
 * @param {Object} state - Redux state.
 * @returns {boolean} Fetched flag.
 */
export const selectWhatsNewIsFetched = (state) => get(state, 'whatsNew.isFetched', initialState.isFetched);

/**
 * Whether this backend does not serve the changelog, so requesting it again is pointless.
 * @param {Object} state - Redux state.
 * @returns {boolean} Unavailable flag.
 */
export const selectWhatsNewIsUnavailable = (state) => get(state, 'whatsNew.isUnavailable', initialState.isUnavailable);

/**
 * Error message of the last failed changelog request.
 * @param {Object} state - Redux state.
 * @returns {string|null} Error message.
 */
export const selectWhatsNewError = (state) => get(state, 'whatsNew.error', initialState.error);

/**
 * Ids of every release, used to resolve their seen/unseen state.
 * Memoized so consumers keep a stable reference between dispatches.
 * @returns {string[]} Release ids.
 */
export const selectWhatsNewVersionIds = createSelector(
  [selectWhatsNewVersions],
  (versions) => versions.map((version) => version.id)
);
